import React from "react";
import styles from "../styles/notificaciones.module.css";
import { fmtDate } from "../domain/dateUtils";
import { useNotificacionesData } from "../hooks/useNotificacionesData";
import { useNotificacionesViewModel } from "../hooks/useNotificacionesViewModel";

export default function Notificaciones() {
    const { loading, personas, error } = useNotificacionesData();
    const vm = useNotificacionesViewModel(personas);

    if (loading) {
        return (
            <div className="notif-view">
                <div className="loading">Cargando notificaciones…</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="notif-view">
                <div className="error">
                    <strong>Ha ocurrido un error:</strong> {error}
                </div>
            </div>
        );
    }

    return (
        <div className={styles["notif-view"]}>
            <div className={styles.titlebar}>
                <div>
                    <h2 className={styles.title}>Alertas</h2>
                    <p className={styles.subtitle}>Caducidades de documentos, licencias y seguros</p>
                </div>
            </div>

            <div className={styles["controls-grid"]}>
                <div className={styles["controls-card"]}>
                    <div className={styles["controls-title"]}>Filtros</div>
                    <div className={styles["controls-row"]}>
                        <input
                            className={styles.input}
                            placeholder="Buscar (persona, tipo, Nº licencia, compañía…)"
                            value={vm.query}
                            onChange={(e) => vm.setQuery(e.target.value)}
                        />
                        <select className={styles.input} value={vm.estado} onChange={(e) => vm.setEstado(e.target.value)}>
                            <option value="all">Todas</option>
                            <option value="expired">Vencidas</option>
                            <option value="soon">Próximas</option>
                            <option value="missing">Sin fecha</option>
                        </select>
                        <select className={styles.input} value={vm.horizon} onChange={(e) => vm.setHorizon(Number(e.target.value))}>
                            <option value={30}>En 30 días (1 mes)</option>
                            <option value={60}>En 60 días (2 meses)</option>
                            <option value={90}>En 90 días (3 meses)</option>
                            <option value={180}>En 180 días (6 meses)</option>
                        </select>
                        <select className={styles.input} value={vm.tipo} onChange={(e) => vm.setTipo(e.target.value)}>
                            <option value="all">Todos los tipos</option>
                            <option value="personaDoc">Documento</option>
                            <option value="licArmas">Licencia de armas</option>
                            <option value="licCaza">Licencia de caza</option>
                            <option value="seguro">Seguro</option>
                        </select>
                    </div>
                </div>

                <div className={styles["controls-card"]}>
                    <div className={styles["controls-title"]}>Orden</div>
                    <div className={styles["controls-row"]}>
                        <select className={styles.input} value={vm.sortBy} onChange={(e) => vm.setSortBy(e.target.value)}>
                            <option value="days">Orden: Días restantes</option>
                            <option value="fecha">Orden: Fecha</option>
                            <option value="persona">Orden: Persona</option>
                            <option value="tipo">Orden: Tipo</option>
                        </select>
                    </div>

                    <hr className={styles.separator} />

                    <div className={styles["controls-title"]}>Agrupar</div>
                    <div className={styles["controls-row"]}>
                        <label className={styles.switch}>
                            <input
                                type="checkbox"
                                checked={vm.groupByPerson}
                                onChange={(e) => vm.setGroupByPerson(e.target.checked)}
                            />
                            <span>Agrupar por persona</span>
                        </label>
                    </div>
                </div>
            </div>

            <div className={styles.kpis}>
                <div className={styles.kpi}>
                    <span className={styles["kpi-title"]}>Total</span>
                    <span className={styles["kpi-value"]}>{vm.kpi.total}</span>
                </div>
                <div className={styles.kpi}>
                    <span className={styles["kpi-title"]}>Vencidas</span>
                    <span className={styles["kpi-value"]}>{vm.kpi.cad}</span>
                </div>
                <div className={styles.kpi}>
                    <span className={styles["kpi-title"]}>Próximas</span>
                    <span className={styles["kpi-value"]}>{vm.kpi.soon}</span>
                </div>
            </div>

            {vm.filtered.length === 0 ? (
                <div className={styles.empty}>
                    <div className={styles.emoji}>🔔</div>
                    <h3>Sin notificaciones</h3>
                    <p>No hay caducidades en el rango seleccionado.</p>
                </div>
            ) : vm.groupByPerson ? (
                <div className={styles["card-list"]}>
                    {vm.grouped.map((grp) => (
                        <article key={grp.personId} className={`${styles.card} ${styles["person-card"]}`}>
                            <header className={styles["person-head"]}>
                                <div className={styles.avatar}>{(grp.personName?.[0] || "?").toUpperCase()}</div>
                                <div className={styles.title}>
                                    <div className={styles.name}>{grp.personName}</div>
                                    <div className={`${styles.muted} ${styles.small}`}>{grp.items.length} aviso(s)</div>
                                </div>
                            </header>

                            <div className={styles["person-body"]}>
                                <div className={styles["table-wrap"]}>
                                    <table className={`${styles.table} ${styles.responsive}`}>
                                        <thead>
                                            <tr>
                                                <th>Tipo</th>
                                                <th>Detalle</th>
                                                <th>Fecha</th>
                                                <th>Días</th>
                                                <th>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {grp.items.map((a) => (
                                                <tr key={a.id}>
                                                    <td data-label="Tipo">{a.label}</td>
                                                    <td data-label="Detalle" className={styles.muted}>{a.meta || "—"}</td>
                                                    <td data-label="Fecha">{fmtDate(a.fecha)}</td>
                                                    <td data-label="Días">{a.daysLeft ?? "—"}</td>
                                                    <td data-label="Estado">
                                                        <span className={`${styles.pill} ${a.status === "expired" ? styles.danger : styles.warn}`}>
                                                            {a.status === "expired" ? "Vencida" : a.status === "soon" ? "Próxima" : "Sin fecha"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            ) : (
                <div className={styles["table-wrap"]}>
                    <table className={`${styles.table} ${styles.responsive}`}>
                        <thead>
                            <tr>
                                <th>Persona</th>
                                <th>Tipo</th>
                                <th>Detalle</th>
                                <th>Fecha</th>
                                <th>Días</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vm.filtered.map((a) => (
                                <tr key={a.id}>
                                    <td data-label="Persona">{a.personName}</td>
                                    <td data-label="Tipo">{a.label}</td>
                                    <td data-label="Detalle" className={styles.muted}>{a.meta || "—"}</td>
                                    <td data-label="Fecha">{fmtDate(a.fecha)}</td>
                                    <td data-label="Días">{a.daysLeft ?? "—"}</td>
                                    <td data-label="Estado">
                                        <span className={`${styles.pill} ${a.status === "expired" ? styles.danger : styles.warn}`}>
                                            {a.status === "expired" ? "Vencida" : a.status === "soon" ? "Próxima" : "Sin fecha"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
